import { Injectable } from '@angular/core';
import { User } from './user';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AuthenticationService {
  private MatrixToolsUserKey = 'Redpill';

  constructor(private http: HttpClient) { }

  public getCurrentUser(): User {
    let matrixUser = localStorage.getItem(this.MatrixToolsUserKey);
    if (!matrixUser)
      return null;

    return JSON.parse(matrixUser);
  }

  public refreshCurrentUser(): User {
    let user = this.getCurrentUser();
    if (!user) {
      return null;
    }

    this.http.get('/api/portal/users/' + user.email)
      .subscribe((user: User) => {
        if (user) {
          localStorage.setItem(this.MatrixToolsUserKey, JSON.stringify(user));
          return user;
        }
        return null;
      });
  }

  public login(email: string, password: string) {
    return this.http.post('/api/portal/login', { 'email': email, 'password': password })
      .pipe(map(user => {
        if (!user) {
          localStorage.removeItem(this.MatrixToolsUserKey);
          return null;
        } else {
          localStorage.setItem(this.MatrixToolsUserKey, JSON.stringify(user));
          return user;
        }
      }));
  }

  public logout() {
    localStorage.removeItem(this.MatrixToolsUserKey);
    window.location.reload();
  }
}
